module.exports = __webpack_public_path__ + "static/media/leijona.72dccc85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/modal/leijona.svg
// module id = 1681
// module chunks = 0